<div id="c-landing-holiday" class="c-landing" *ngIf="isLoaded">
  <app-holiday-detail *ngIf="!isGenericDetail"></app-holiday-detail>
  <holiday-detail-generic-page *ngIf="isGenericDetail"></holiday-detail-generic-page>
</div>